// The genealogy chain of a product batch, resolved the way the engine resolves it: each link in turn, and another
// kind only through an explicit same_as (DECISIONS E-15). Shared by the genealogy and data entry screens.
import { allNodes, links } from './data.ts';

export interface Step {
  kind: string;
  id: string | null;
  sameAs: string | null;
}

export async function batchChain(id: string): Promise<{ steps: Step[]; prodCode: string | null }> {
  const [nodes, ls] = await Promise.all([allNodes(), links()]);
  const kindOf = new Map(nodes.map((n) => [n.node_id, n.kind]));
  const linkOf = new Map(ls.map((l) => [`${l.from_node}|${l.link}`, l]));
  const follow = (from: string | null, link: string): Step => {
    const l = from ? linkOf.get(`${from}|${link}`) : undefined;
    const target = l?.to_node ?? null;
    const ok = target !== null && kindOf.get(target) === (l?.same_as ?? link);
    return { kind: link, id: ok ? target : null, sameAs: ok ? (l?.same_as ?? null) : null };
  };
  const parent = follow(id, 'parent');
  const harvest =
    parent.sameAs === 'harvest'
      ? { kind: 'harvest', id: parent.id, sameAs: null }
      : follow(parent.id, 'harvest');
  const cult =
    harvest.sameAs === 'cultivation'
      ? { kind: 'cultivation', id: harvest.id, sameAs: null }
      : follow(harvest.id, 'cultivation');
  const steps = [
    { kind: 'product_batch', id, sameAs: null },
    parent,
    harvest,
    cult,
    follow(cult.id, 'strain_lot'),
    follow(cult.id, 'raw_water'),
  ];
  return { steps, prodCode: nodes.find((n) => n.node_id === id)?.prod_code ?? null };
}
